import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const faqs = [
  {
    question: "Quanto custa o serviço de SDR as a Service?",
    answer:
      "Cada proposta é personalizada com base no seu ICP, volume de prospecção e metas. Oferecemos um diagnóstico gratuito onde apresentamos valores e projeção de ROI — sem compromisso.",
  },
  {
    question: "Preciso assinar contrato de fidelidade?",
    answer:
      "Não. Trabalhamos sem contrato de fidelidade. Você fica porque vê resultado, não porque está preso. Simples assim.",
  },
  {
    question: "Em quanto tempo vejo os primeiros resultados?",
    answer:
      "Nossos clientes começam a receber reuniões qualificadas em até 45 dias úteis. Já nas primeiras semanas você recebe reports de progresso com métricas claras.",
  },
  {
    question: "Como funciona o acompanhamento?",
    answer:
      "Você recebe reports semanais detalhados com métricas de performance, volume de abordagens, taxas de resposta e reuniões agendadas. Total transparência.",
  },
  {
    question: "Posso pausar ou cancelar o serviço?",
    answer:
      "Sim. Oferecemos total flexibilidade. Você pode pausar ou cancelar a qualquer momento, sem multas ou burocracia.",
  },
];

export const FAQ = () => {
  return (
    <section id="faq" className="py-24 bg-background">
      <div className="container mx-auto px-4 max-w-3xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <span className="inline-block px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">
            Dúvidas Frequentes
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground">
            Perguntas que nossos clientes fazem{" "}
            <span className="text-gradient">antes de começar</span>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`faq-${index}`}
                className="bg-card border border-border rounded-xl px-6 data-[state=open]:shadow-md transition-shadow"
              >
                <AccordionTrigger className="text-left text-foreground font-semibold hover:no-underline py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};
